import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {PaymentMethodsListFilter} from './PaymentMethodsListFilter'

const PaymentMethodsListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddPaymentMethodModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-paymentmethod-table-toolbar='base'>
      <PaymentMethodsListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' defaultMessage={"Export"} />      </button>
      {/* end::Export */}

      {/* begin::Add paymentmethod */}
      <button type='button' className='btn btn-primary' onClick={openAddPaymentMethodModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='PAYMENTMETHOD.TABLE.CREATEPAYMENTMETHOD' defaultMessage={"Create New"} />
      </button>
      {/* end::Add paymentmethod */}
    </div>
  )
}

export {PaymentMethodsListToolbar}
